import React from 'react';
import { EVENT_DATE, CALL_FOR_SPEAKERS_URL } from '../config.js';

const ComingSoon = () => (
    <section className='w-11/12 my-10 mx-auto bg-DFBackground py-16 px-6 rounded-2xl text-center'>
        <div className="inline-flex items-center mb-4">
            <span className="text-5xl font-bold text-DFBlue">{'{'}</span>
            <h1 className="text-5xl font-bold mx-3 text-black">DevFest</h1>
            <span className="text-5xl font-bold text-DFGreen">{'}'}</span>
        </div>
        <div className="flex justify-center items-center my-2 gap-2">
            <span className="bg-white text-black px-4 py-2 rounded-full border-2 border-black font-bold text-lg">London</span>
            <span className="text-white px-4 py-2 rounded-full border-2 border-black font-bold text-lg bg-DFBlue">{EVENT_DATE}</span>
        </div>

        <h2 className='text-3xl sm:text-4xl font-bold text-black mt-8 mb-3'>Stay tuned!</h2>
        <p className='max-w-2xl mx-auto sm:text-lg text-gray-700 my-2'>
            DevFest London is happening on <span className='font-semibold text-DFBlue'>{EVENT_DATE}</span>.
            More info will be posted in the next few weeks.
        </p>

        <div className='max-w-2xl mx-auto mt-10 p-8 bg-white rounded-2xl border-2 border-black shadow-lg'>
            <h3 className='text-2xl font-bold text-black mb-2'>🎤 Call for Speakers is open</h3>
            <p className='sm:text-lg text-gray-700 mb-6'>
                In the meantime, we are looking for amazing speakers. Please submit a talk!
            </p>
            <a
                href={CALL_FOR_SPEAKERS_URL}
                target='_blank'
                rel='noopener noreferrer'
                className="inline-flex items-center gap-3 bg-gradient-to-r from-DFBlue to-DFGreen text-white px-10 py-4 rounded-xl font-bold text-lg hover:opacity-90 transition-all shadow-lg hover:shadow-xl hover:scale-105"
                style={{ textDecoration: 'none' }}
            >
                <span>Submit a Talk</span>
                <span className="opacity-80">→</span>
            </a>
        </div>
    </section>
);

export default ComingSoon;
